/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddDeviceDtoTx,
  Common,
  CreateFacilityReportDtoRx,
  CreateFacilityStep2Dto,
  CreateInspectionLogDtoTx,
  DeleteFacilityDtoTx,
  DeleteInspectionLogDtoTx,
  FacilityControllerCreateFacilityReportParams,
  FacilityControllerGetEventsParams,
  FacilityControllerGetFacilitiesParams,
  FacilityControllerGetFacilityDevicesParams,
  FacilityControllerGetFacilityDuplicateParams,
  FacilityControllerGetInspectionLogsParams,
  GetFacilitiesDtoRx,
  GetFacilityDeviceDtoRx,
  GetFacilityDevicesDtoRx,
  GetFacilityDtoRx,
  GetFacilityEventDtoRx,
  GetFileUrlDtoRx,
  GetInspectionLogDtoRx,
  GetUpdateFacilityStepDto,
  GetUpdateInspectionLogDtoRx,
  TotalCoumn,
  UpdateFacilityStep1Dto,
  UpdateInspectionLogDtoTx,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class FacilityApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerGetFacilities
   * @summary 시설물 목록 조회
   * @request GET:/api/facility
   * @secure
   */
  facilityControllerGetFacilities = (query: FacilityControllerGetFacilitiesParams, params: RequestParams = {}) =>
    this.request<
      {
        totalColumn?: number;
        results?: GetFacilitiesDtoRx[];
      },
      any
    >({
      path: `/api/facility`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerCreateFacility
   * @summary 시설물 등록
   * @request POST:/api/facility
   * @secure
   */
  facilityControllerCreateFacility = (data: CreateFacilityStep2Dto, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/facility`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerDeleteFacility
   * @summary 시설물 삭제
   * @request DELETE:/api/facility
   * @secure
   */
  facilityControllerDeleteFacility = (data: DeleteFacilityDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/facility`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerGetFacilityDuplicate
   * @summary 시설물 중복 조회
   * @request GET:/api/facility/duplicate
   * @secure
   */
  facilityControllerGetFacilityDuplicate = (
    query: FacilityControllerGetFacilityDuplicateParams,
    params: RequestParams = {},
  ) =>
    this.request<Common, any>({
      path: `/api/facility/duplicate`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerGetFacilityCount
   * @summary 시설물 수 조회
   * @request GET:/api/facility/count
   * @secure
   */
  facilityControllerGetFacilityCount = (params: RequestParams = {}) =>
    this.request<TotalCoumn, any>({
      path: `/api/facility/count`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerGetFacility
   * @summary 시설물 상세 조회
   * @request GET:/api/facility/{id}
   * @secure
   */
  facilityControllerGetFacility = (id: number, params: RequestParams = {}) =>
    this.request<GetFacilityDtoRx, any>({
      path: `/api/facility/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerUpdateFacility
   * @summary 시설물 수정
   * @request PUT:/api/facility/{id}
   * @secure
   */
  facilityControllerUpdateFacility = (id: number, data: UpdateFacilityStep1Dto, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/facility/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerGetFacilityDevices
   * @summary 설치 디바이스 조회
   * @request GET:/api/facility/{id}/devices
   * @secure
   */
  facilityControllerGetFacilityDevices = (
    { id, ...query }: FacilityControllerGetFacilityDevicesParams,
    params: RequestParams = {},
  ) =>
    this.request<GetFacilityDeviceDtoRx, any>({
      path: `/api/facility/${id}/devices`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerGetUpdateFacility
   * @summary 시설물 수정에 필요한 데이터 반환
   * @request GET:/api/facility/{id}/update
   * @secure
   */
  facilityControllerGetUpdateFacility = (id: number, params: RequestParams = {}) =>
    this.request<GetUpdateFacilityStepDto, any>({
      path: `/api/facility/${id}/update`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerCreateDevice
   * @summary 디바이스 추가
   * @request POST:/api/facility/{id}/device
   * @secure
   */
  facilityControllerCreateDevice = (id: number, data: AddDeviceDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/facility/${id}/device`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerGetEvents
   * @summary 이벤트 발생 내역 조회
   * @request GET:/api/facility/{id}/events
   * @secure
   */
  facilityControllerGetEvents = ({ id, ...query }: FacilityControllerGetEventsParams, params: RequestParams = {}) =>
    this.request<GetFacilityEventDtoRx, any>({
      path: `/api/facility/${id}/events`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerGetLocation
   * @summary 위치 정보 조회
   * @request GET:/api/facility/{id}/location
   * @secure
   */
  facilityControllerGetLocation = (id: number, params: RequestParams = {}) =>
    this.request<GetFacilityDevicesDtoRx, any>({
      path: `/api/facility/${id}/location`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerCreateFacilityReport
   * @summary 리포트 생성
   * @request POST:/api/facility/{id}/report
   * @secure
   */
  facilityControllerCreateFacilityReport = (
    { id, ...query }: FacilityControllerCreateFacilityReportParams,
    params: RequestParams = {},
  ) =>
    this.request<CreateFacilityReportDtoRx, any>({
      path: `/api/facility/${id}/report`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerGetInspectionLogs
   * @summary 점검 일지 조회
   * @request GET:/api/facility/{id}/inspectionlog
   * @secure
   */
  facilityControllerGetInspectionLogs = (
    { id, ...query }: FacilityControllerGetInspectionLogsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetInspectionLogDtoRx, any>({
      path: `/api/facility/${id}/inspectionlog`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerCreateInspectionLog
   * @summary 점검 일지 추가
   * @request POST:/api/facility/{id}/inspectionlog
   * @secure
   */
  facilityControllerCreateInspectionLog = (id: number, data: CreateInspectionLogDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/facility/${id}/inspectionlog`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerDeleteInspectionLog
   * @summary 점검 일지 삭제
   * @request DELETE:/api/facility/{id}/inspectionlog
   * @secure
   */
  facilityControllerDeleteInspectionLog = (id: number, data: DeleteInspectionLogDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/facility/${id}/inspectionlog`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerGetInspectionLog
   * @summary 점검 일지 상세 조회(파일 URL 반환)
   * @request GET:/api/facility/{id}/inspectionlog/{inspectionlogid}
   * @secure
   */
  facilityControllerGetInspectionLog = (id: number, inspectionlogid: number, params: RequestParams = {}) =>
    this.request<GetFileUrlDtoRx, any>({
      path: `/api/facility/${id}/inspectionlog/${inspectionlogid}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerUpdateInspectionLog
   * @summary 점검 일지 수정
   * @request PUT:/api/facility/{id}/inspectionlog/{inspectionlogid}
   * @secure
   */
  facilityControllerUpdateInspectionLog = (
    id: number,
    inspectionlogid: number,
    data: UpdateInspectionLogDtoTx,
    params: RequestParams = {},
  ) =>
    this.request<Common, any>({
      path: `/api/facility/${id}/inspectionlog/${inspectionlogid}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Facility API
   * @name FacilityControllerGetInspectionLogForUpdate
   * @summary 점검 일지 수정에 필요한 데이터 반환
   * @request GET:/api/facility/{id}/inspectionlog/{inspectionlogid}/update
   * @secure
   */
  facilityControllerGetInspectionLogForUpdate = (id: number, inspectionlogid: number, params: RequestParams = {}) =>
    this.request<GetUpdateInspectionLogDtoRx, any>({
      path: `/api/facility/${id}/inspectionlog/${inspectionlogid}/update`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
